module.exports = __webpack_public_path__ + "img/DOLLAR_SIGN.dd1c1e33.svg";